import type { HTMLAttributes, ReactNode } from "react";

export type StatusTone = "neutral" | "info" | "success" | "warning" | "danger";

export interface StatusPillProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: StatusTone;
  children: ReactNode;
}

export function StatusPill({
  tone = "neutral",
  children,
  className,
  ...rest
}: StatusPillProps) {
  return (
    <span
      {...rest}
      className={["rp-pill", `rp-pill--${tone}`, className]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </span>
  );
}
